module.exports = __webpack_public_path__ + "static/media/Team 11 - Comrades.ed9cef80.jpg";